// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ba3a3dd","453":"720ecbfd","455":"3757f7a1"}[chunkId] + ".chunk.js";
};